import { LocationDetailsDto } from './locationService.dto';

export const DEFAULT_MARKER_RADIUS_MILES = 2;
export const MILE_TO_METERS = 1609;
export const GEO_DEGREE_TO_MILES = 67;
export const RADIUS_FACTOR = 5;
export const AUTOCOMPLETE_MIN_LENGTH = 2;
export const AUTOCOMPLETE_DEBOUNCE_MS = 200;

export const DEFAULT_LOCATION: LocationDetailsDto = {
  locationSource: 'APP_CONST',
  latitude: 40.7830603,
  longitude: -73.9712488,
  countryCode: 'US',
  state: 'NY',
  city: 'New York',
  zipCode: '10024',
};

export const calculateRegionZoom = (radiusInMiles?: number) => {
  if (!radiusInMiles) return 12;
  const latitudeDelta = RADIUS_FACTOR * (radiusInMiles / GEO_DEGREE_TO_MILES);
  return Math.max(8, Math.min(14, Math.round(Math.log2(360 / latitudeDelta) - 1)));
};
